import { useState, useEffect } from 'react'

import PlayMusic from '@/pages/hmt/official/components/play-music'
import useTA, { EventType } from '@/pages/hmt/hooks/useTA'
import { isPC } from '@/utils'
import BaseLayout from '../base-layout'

const getShowAihelpFlag = () => {
  const params = new URLSearchParams(window.location.search)
  const showaihelp = params.get('showaihelp')
  if (showaihelp === '1') return true
  return false
}

const showMusicPlayer = [
  'endorse',
  '/official/webview/news/list',
  '/official/webview/live',
].every((item) => !window.location.pathname.includes(item))

/**
 * OfficialLayout
 */
const OfficialLayout = (props: any) => {
  const [showAihelpFlag, setShowAihelpFlag] = useState(false)
  const { isFromAd, reportTrack } = useTA()

  /**
   * 初始进入页面是否打开 aihelp
   */
  useEffect(() => {
    setShowAihelpFlag(getShowAihelpFlag())
  }, [])

  useEffect(() => {
    if (!isFromAd()) return
    reportTrack(EventType.PcPageview)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <BaseLayout {...props}>
      {isPC() && showMusicPlayer && <PlayMusic page="pc" />}
    </BaseLayout>
  )
}

export default OfficialLayout
